export enum SETTINGS {
  API_DATE_FORMAT = 'yyyy-MM-dd',
  FULL_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss',
  HOURS_DATE_FORMAT = 'HH:mm:ss',
  TABLET_VIEW = '(max-width: 768px)',
  MOBILE_VIEW = '(max-width: 425px)',
  TOAST_LIFETIME = 8000,
  DEFAULT_PAGE = '/scales-indications',
}
